import { render, staticRenderFns } from "./painel.vue?vue&type=template&id=003135af&scoped=true&"
import script from "./painel.vue?vue&type=script&lang=js&"
export * from "./painel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003135af",
  null
  
)

export default component.exports